<mat-drawer-container [hasBackdrop]="true" style="background-color: #ffffff;">
  <mat-drawer
    #drawer
    mode="over"
    [(opened)]="drawerOpen"
    position="end">
    <div class="row" class="side-drawer">
      <div class="col-md-12">
        <button mat-icon-button
          type="button"
          id="close-drawer-icon"
          (click)="drawer.toggle()"
          aria-label="close drawer" class="float-right small-button">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
        <br />
         <div *ngIf="_drawerContent && _drawerContent.response && _drawerContent.crmQualificationError">
          <h5>We noticed your response...</h5>
          <div [innerHTML]="_drawerContentError"></div>
          <hr />
        </div>
        <div *ngIf="_drawerContent && _drawerContent.crmQualificationHelp" [innerHTML]='_drawerContentHelp'></div>
      </div>
    </div>
    <div class="row" style="margin-right: 0; margin-left: 0;">
      <div class="col-md-12">
        <br />
        <button
          type="button"
          id="close-drawer-button"
          mat-raised-button
          (click)="drawer.toggle()">
          CLOSE
        </button>
      </div>
    </div>
</mat-drawer>
<mat-drawer-content>
  <section class="row" style="margin-right: 0; margin-left: 0;">
    <div class="col-md-12 questionnaire">
      <div *ngIf="sortedQuestions.length != 0"
       class="progress">
        <div
          class="progress-bar bg-info"
          role="progressbar"
          [ngStyle]="{ 'width': progressDisplay }"
          [attr.aria-valuenow]="progressDisplay"
          aria-valuemin="0"
          aria-valuemax="100">
            Progress {{ progressIndicator }}/{{ sortedQuestions.length }}
        </div>
      </div>
      <br/>
      <div *ngIf="sortedQuestions.length == 0">
        Error: No qualification questions are available for this program. Please contact support if you continue to get this error.<br /><br />
        <button
          mat-button
          class="go-back"
          id="go-back-button"
          (click)="previousPage()">
            GO BACK
        </button>
      </div>
      <form [formGroup]="questionForm" *ngIf="questionForm">
        <div *ngFor="let questionSet of sortedQuestions; let i = index;">
          <div
            class="row"
            *ngIf="progressIndicator === questionSet[0].questionSet"
            [formGroupName]="'set' + (i + 1)">
              <div class="col-md-12" *ngFor="let question of questionSet">
                <div class="row">
                  <div class="col-md-12 question-sentence" [innerHTML]="question.questionSentence"></div>
                  <div *ngIf="question.definitions" class="col-md-12 question-definitions" [innerHTML]="question.definitions"></div>
                </div>
                <div class="row" >
                  <div [className]="question.inputSelectedValidStyle + ' col-md-12'">
                    <!-- Yes-No Question -->
                      <mat-button-toggle-group [id]="question.controlName"
                        *ngIf="question.inputTypeOptionSet !== 'Select'"
                        [formControlName]="question.controlName"
                        (change)="qualifierAnswered($event.value, question)" >
                          <mat-button-toggle value="Yes" [id]="(question.controlName + 'Yes')">
                            YES
                          </mat-button-toggle>
                          <mat-button-toggle color="accent" value="No" [id]="(question.controlName + 'No')">
                            NO
                          </mat-button-toggle>
                      </mat-button-toggle-group>
                    <!-- /Yes-No Question -->

                    <!-- Select Question -->
                    <div style="display: inline-flex;" *ngIf="question.inputTypeOptionSet === 'Select'">
                      <mat-form-field
                        appearance="outline">
                        <mat-label>Choose an option</mat-label>
                        <mat-select
                          [id]="(question.controlName)"
                          [formControlName]="question.controlName"
                          (selectionChange)="qualifierAnswered($event.value, question)">
                          <mat-option
                            *ngFor="let answer of question.inputValues; let i = index"
                            [id]="(question.controlName + i)"
                            [value]="answer">
                            {{ answer }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline"
                      *ngIf="question.controlName === 'source' && question.inputSelectedValue && question.inputSelectedValue.trim() === 'Other'">
                        <mat-label>Please Specify Other:</mat-label>
                        <input
                          matInput
                          [formControlName]="(question.controlName + 'Other')"
                          class="row"
                          type="text"
                          [id]="(question.controlName + 'Other')"
                          maxlength="60"
                          (blur)="qualifierOtherAnswered($event, question)"
                          >
                      </mat-form-field>
                    </div>
                    <!-- /Select Question -->
                    <div class="question-status">
                      <mat-icon class="valid" aria-hidden="false" [attr.aria-label]="question.questionHelpMessage">check_circle</mat-icon>
                      <mat-icon class="invalid" aria-hidden="false" [attr.aria-label]="question.questionHelpMessage">error</mat-icon>
                    </div>
                    <!-- More Information -->
                    <button
                      mat-button
                      [hidden]="!showMoreInfo(question)"
                      type="button"
                      [id]="(question.controlName + '-more-info')"
                      class="more-info"
                      [attr.aria-label]="('More Info: ' + question.questionSentence)"
                      (click)="qualifierMoreInfo(question)">
                        MORE INFO
                    </button>
                    <!-- /More Information -->
                  </div>
                </div>
                <br/>
                <br/>
              </div>
          </div>
        </div>
        <button
          mat-button
          class="go-back"
          id="go-back-stepper-button"
          (click)="previousPage()">
            GO BACK
        </button>
        <button
            *ngIf="progressIndicator !== sortedQuestions.length"
            mat-raised-button
            type="button" color="primary"
            class="next-step float-right"
            id="section-stepper-button"
            (click)="nextPage()"
            [disabled]="!nextStepEnabled(progressIndicator)">
          NEXT STEP
        </button>
        <button
          *ngIf="progressIndicator === sortedQuestions.length"
          mat-raised-button
          matStepperNext
          type="button" color="primary"
          class="next-step float-right"
          id="main-stepper-button"
          [disabled]="!nextStepEnabled(progressIndicator)">
            NEXT STEP
        </button>
        <br /><br /><br />
        </form>
      </div>
    </section>
  </mat-drawer-content>
</mat-drawer-container>
